import request from '@/utils/request'

export function getScheduleAdjHistory(requestDetailId) {
  return request({
    url: `/api/scheduleAdjAnswer/partner/schedule/history/${requestDetailId}`,
    method: 'get',
  })
}
